export default function GradientHouseIcon({ width = "100", height = "100", style = {} }) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        <defs>
          <linearGradient id="vendorleadsIconGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style={{ stopColor: "#10b981", stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: "#3b82f6", stopOpacity: 1 }} />
          </linearGradient>
        </defs>
        <path
          d="M 12 52 L 12 30 L 32 10 L 52 30 L 52 52 Z"
          fill="none"
          stroke="url(#vendorleadsIconGradient)" // Unique ID if used on same page as text
          strokeWidth="10" // Note: strokeWidth is camelCase in JSX
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }